import { render, staticRenderFns } from "./user-menu.vue?vue&type=template&id=5a01d41c&scoped=true&"
import script from "./user-menu.vue?vue&type=script&lang=js&"
export * from "./user-menu.vue?vue&type=script&lang=js&"
import style0 from "./user-menu.vue?vue&type=style&index=0&id=5a01d41c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a01d41c",
  null
  
)

export default component.exports